module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.154/js/sprocket_white.svg"